export enum FORM_OF_PAYMENTS {
  None = 0,
  Cash = 1,
  Transfer = 5,
  TransferPrePayment = 7,
  CreditCard = 8,
  CashTerm = 9,
  BankStatementManual = 10,
  BankStatementAuto = 11,
  Compensation = 12,
  Voucher = 13,
  OtherOperationalCosts = 14,
  CreditCardSystem = 15,
  CreditCardTerminal = 16,
  PayPal = 17,
  Transfer24 = 18,
  SIX = 19,
  SIXMRX = 20,
  ENETT = 21,
  ITAOTransfer = 22,
  UncollectibleBalance = 23,
  DisputedCase = 24,
  CourtSettlement = 25,
  NonTaxDeductibleExpenses = 26,
  CompanyLoss = 27,
  Paynow = 28,
  PaynowPrePayment = 29,
  SettlementCashExpenses = 30,
  CreditCardPurchase = 31,
  OtherOperationalIncome = 32,
  Blik = 33,
}
